import React from 'react';

const TestModeSection = ({ clinic, editedClinic, setEditedClinic, isEditing }) => {
  const settings = isEditing ? editedClinic?.settings : clinic?.settings;
  const testMode = settings?.test_mode;
  const authorizedNumbers = Array.isArray(testMode?.authorized_numbers)
    ? testMode.authorized_numbers
    : [];

  console.log('TestModeSection - isEditing:', isEditing);
  console.log('TestModeSection - testMode:', testMode);

  const handleFieldChange = (field, value) => {
    if (!isEditing) return;
    setEditedClinic(prev => ({
      ...prev,
      settings: {
        ...prev.settings || {},
        test_mode: {
          ...prev.settings?.test_mode || {},
          [field]: value
        }
      }
    }));
  };

  const addNumber = () => {
    handleFieldChange('authorized_numbers', [...authorizedNumbers, '']);
  };

  const updateNumber = (index, value) => {
    const next = [...authorizedNumbers];
    next[index] = value;
    handleFieldChange('authorized_numbers', next);
  };

  const removeNumber = (index) => {
    const next = [...authorizedNumbers];
    next.splice(index, 1);
    handleFieldChange('authorized_numbers', next);
  };

  if (!isEditing) {
    // Read-only view
    return (
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-md font-semibold mb-4">Test Mode</h4>

        <div className="flex items-center mb-4">
          <span className="text-sm font-medium text-gray-700 mr-2">Status:</span>
          <span
            className={`px-2 py-1 text-xs rounded-full ${testMode?.enabled ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-700'}`}
          >
            {testMode?.enabled ? 'Enabled' : 'Disabled'}
          </span>
        </div>

        {testMode?.enabled && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Authorized WhatsApp Numbers
            </label>
            {authorizedNumbers.filter(Boolean).length ? (
              <ul className="list-disc list-inside space-y-1">
                {authorizedNumbers.filter(Boolean).map((number, index) => (
                  <li key={index} className="text-sm text-gray-900">{number}</li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">No authorized numbers - all senders are voided.</p>
            )}
          </div>
        )}
      </div>
    );
  }

  // Edit mode
  return (
    <div className="mt-6 pt-6 border-t border-gray-200">
      <h4 className="text-md font-semibold mb-4">Test Mode</h4>

      <div className="flex items-start space-x-4 mb-4">
        <div className="flex items-center h-5">
          <input
            id="test_mode_enabled"
            name="test_mode_enabled"
            type="checkbox"
            checked={testMode?.enabled || false}
            onChange={(e) => handleFieldChange('enabled', e.target.checked)}
            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="test_mode_enabled" className="font-medium text-gray-700">
            Enable Test Mode
          </label>
          <p className="text-gray-500">
            When enabled, only the authorized WhatsApp numbers below get AI replies. All
            other senders are silently voided (their messages are received but not answered).
          </p>
        </div>
      </div>

      {testMode?.enabled && (
        <div className="space-y-3">
          <label className="block text-sm font-medium text-gray-700">
            Authorized WhatsApp Numbers
          </label>
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {authorizedNumbers.map((number, index) => (
              <div key={index} className="flex items-center space-x-2">
                <input
                  type="text"
                  value={number || ''}
                  onChange={(e) => updateNumber(index, e.target.value)}
                  className="flex-1 p-2 border rounded"
                  placeholder="+85291234567"
                />
                <button
                  type="button"
                  onClick={() => removeNumber(index)}
                  className="px-3 py-2 text-sm text-red-600 border border-red-200 rounded hover:bg-red-50"
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={addNumber}
            className="px-3 py-2 text-sm text-blue-600 border border-blue-200 rounded hover:bg-blue-50"
          >
            + Add Number
          </button>
          <p className="mt-1 text-xs text-gray-500">
            Matching ignores '+', spaces and dashes. Leaving this list empty while test mode
            is enabled voids every sender.
          </p>
        </div>
      )}
    </div>
  );
};

export default TestModeSection;
